import UserPage from "src/pages/User";
import { createGetServerSideProps } from "src/utilities/ssr/createGetServerSideProps";
import {
  getUserServerSideProps,
  getUserPageDonationsFeed,
} from "src/utilities/ssr/getUserServerSideProps";
import { withPropsDeserialization } from "src/utilities/ssr/withPropsDeserialization";

export const getServerSideProps = createGetServerSideProps(
  getUserServerSideProps(getUserPageDonationsFeed)
);

export default withPropsDeserialization(UserPage);
